import { getArticleDescription } from '../../apis/metaData';
import { articleMetaTagString } from '../../utilities/meta_tags_util';
import { checkImgType } from '../../utilities/image_util';
import { getLanguageByRank } from '../../utilities/language';

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;
const ARTICLE_SUCCESS = 1;

async function loadData(urlPath, language, query, params, headers) {
  if (!params) {
    return {
      notFound: true,
    };
  }

  const { userid, articleid } = params;
  if (!userid || !articleid) {
    return {
      notFound: true,
    };
  }
  const secretId = getSecretId();

  try {
    const response = await getArticleDescription(userid, articleid, secretId);
    const { data } = response;

    if (data.code !== ARTICLE_SUCCESS) {
      return {
        notFound: true,
      };
    }

    const {
      data: {
        article: {
          title,
          description,
          nickname,
          cover,
          noindex,
          language: authorLanguage,
        },
      },
    } = data;
    const metaLanguage = getLanguageByRank(
      query.hl,
      authorLanguage,
      headers['accept-language'],
    );
    const image = checkImgType({ data: cover, isSSR: true });
    const htmlLang = authorLanguage || 'en';
    const metaData = articleMetaTagString({
      urlPath,
      title,
      description,
      nickname,
      image,
      noindex,
      language: metaLanguage,
    });

    return {
      metaData,
      htmlLang,
    };
  } catch (error) {
    console.log(error);
    return {
      metaData: null,
    };
  }
}

export default loadData;
